import { useEffect, useState } from "react";
import api, { apiError } from "../../../lib/api";
import { toast } from "sonner";

export function Questions() {
  const [qs, setQs] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/questions").then((r) => setQs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const answer = async (q) => {
    setBusy(true);
    try {
      await api.patch(`/admin/questions/${q.question_id}`, { answer: drafts[q.question_id] });
      toast.success("Answered. The exchange is now on record for all members.");
      setDrafts({ ...drafts, [q.question_id]: "" });
      load();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl space-y-0" data-testid="admin-questions">
      {qs.map((q) => (
        <div key={q.question_id} className="hairline py-5" data-testid={`admin-question-${q.question_id}`}>
          <div className="flex gap-6 items-baseline flex-wrap">
            <span className="t-label">{q.company}</span>
            <span className="t-cap text-muted-s">{q.member_email}</span>
            <span className="t-cap text-muted-s fig">{q.created_at?.slice(0, 10)}</span>
          </div>
          <p className="t-body text-bone mt-2">{q.question}</p>
          {q.answer ? (
            <div className="mt-3 pl-5" style={{ borderLeft: "1px solid var(--rule)" }}>
              <span className="t-label">Answered</span>
              <p className="t-small text-muted-s mt-1">{q.answer}</p>
            </div>
          ) : (
            <div className="mt-3 flex gap-3">
              <textarea className="input-solera" rows={2} placeholder="Answer, goes on record for all members"
                value={drafts[q.question_id] || ""} onChange={(e) => setDrafts({ ...drafts, [q.question_id]: e.target.value })}
                data-testid={`answer-input-${q.question_id}`} />
              <button className="btn-primary self-end" disabled={busy || !(drafts[q.question_id] || "").trim()}
                onClick={() => answer(q)} data-testid={`answer-button-${q.question_id}`}>Answer</button>
            </div>
          )}
        </div>
      ))}
      {qs.length === 0 && <p className="t-small text-muted-s">No questions yet.</p>}
    </div>
  );
}
